// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__tqXp4","actions":"GroupTable_actions__1cupn","deleteModalFooter":"GroupTable_deleteModalFooter__2HQot"};